import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const MetadataDisplay = ({ metadata }) => {
  return (
    <Box>
      <Typography variant="h6" component="h3" gutterBottom>
        Video Metadata
      </Typography>
      {metadata ? (
        <Paper elevation={3} style={{ padding: '16px', backgroundColor: '#f5f5f5' }}>
          {metadata.name && <Typography variant="body1"><strong>File Name:</strong> {metadata.name}</Typography>}
          {metadata.timeOfDay && <Typography variant="body1"><strong>Time of Day:</strong> {metadata.timeOfDay}</Typography>}
          {metadata.duration && <Typography variant="body1"><strong>Duration:</strong> {metadata.duration}</Typography>}
          {metadata.gpsCoordinates && <Typography variant="body1"><strong>GPS Coordinates:</strong> {metadata.gpsCoordinates}</Typography>}
        </Paper>
      ) : (
        <Typography variant="body1">No metadata available.</Typography>
      )}
    </Box>
  );
};

export default MetadataDisplay;